import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { useAuth } from "./AuthContext";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";

export default function AdminLogin() {
  const { user, setUser } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  if (user) return <Navigate to="/admin" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const r = await api.post("/auth/login", { email, password });
      setUser(r.data);
      nav("/admin");
    } catch (err) {
      setError(errMsg(err));
    }
    setBusy(false);
  };
  return (
    <div className="gg-admin min-h-screen flex items-center justify-center p-4">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-white/10 bg-[#0d2233] p-8 space-y-5" data-testid="admin-login-form">
        <div>
          <img src="/favicon.svg" alt="" className="w-12 h-12 mb-3" />
          <h1 className="text-2xl font-bold text-white" style={{ fontFamily: "Oswald" }}>Pannello Admin</h1>
          <p className="text-sm text-slate-300">Giochi.Gratis</p>
        </div>
        <div className="space-y-2">
          <Label htmlFor="email" className="text-slate-200">Email</Label>
          <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-login-email" className="bg-white/5 text-white border-white/15" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="pwd" className="text-slate-200">Password</Label>
          <Input id="pwd" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-login-password" className="bg-white/5 text-white border-white/15" />
        </div>
        {error && <p className="text-sm text-red-300" data-testid="admin-login-error">{error}</p>}
        <Button type="submit" disabled={busy} className="w-full bg-[#fc0] text-[#043856] hover:bg-yellow-300 font-bold" data-testid="admin-login-submit">
          {busy ? "Accesso..." : "Accedi"}
        </Button>
      </form>
    </div>
  );
}
